import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, LayerGroup, ZoomControl, Polyline } from 'react-leaflet'
import { BodyCenter } from '../MapContentHolder/MapContentHolder'
import { useSelector } from 'react-redux';


import useStyles from './useStyles'



function ContentContainer(props) {
  const {
    //dispatch
    //redux
    content
  } = props;

  const { paletteWidth } = useSelector((state) => {
    const   paletteWidth  = state?.ui?.paletteWidth;
    return { paletteWidth }
  })
  const classes = useStyles({paletteWidth});

  const st={
    width: paletteWidth ? `calc(100vw - ${paletteWidth+(window.innerWidth > 768 ? 30 : 10)}px)`:'100%',
    right:'0px'
  }

  return (
    <div
    style={st}
    className={classes.map}
    key='map'
    >
      {/* {paletteWidth} */}
      {content}
  </div>

  );
}

export default ContentContainer;
